<template>
  <div class="w-full">
    <IntakeFormWrapper
      :api-url="appApiUrl"
      :api-token="appApiToken"
      :show-initial-message="true"
      :api-headers="apiHeaders"
      @lead-clicked-issue-input="onLeadClickedIssueInput"
      @issue-text-updated="onIssueTextUpdated"
      @issue-submitted="onIssueSubmitted"
      @jurisdiction-text-updated="onJurisdictionTextUpdated"
      @jurisdiction-selection-change="onJurisdictionSelectionChange"
      @jurisdiction-selection-submitted="onJurisdictionSelectionSubmitted"
      @name-text-updated="onNameTextUpdated"
      @email-text-updated="onEmailTextUpdated"
      @phone-number-updated="onPhoneNumberUpdated"
      @contact-details-submitted="onContactDetailsSubmitted"
      @intake-complete="onIntakeComplete"
    />
  </div>
</template>

<script>
import IntakeFormWrapper from './IntakeFormWrapper.vue';

export default {
  name: 'LeadIntake',
  components: {
    IntakeFormWrapper,
  },
  data() {
    return {
      appApiUrl: process.env.MIX_INTAKE_API_URL || 'http://al-client-intake.test/api/v1',
      appApiToken: process.env.MIX_INTAKE_API_TOKEN || 'api-token',
      completedIntakeData: null,
      apiHeaders: {
        // 'X-Custom-Header': 'Header-Value',
      },
    };
  },
  methods: {
    onLeadClickedIssueInput(detail) {
      console.log('Event: onLeadClickedIssueInput', detail);
    },
    onIssueTextUpdated(detail) {
      console.log('Event: onIssueTextUpdated', detail.text);
    },
    onIssueSubmitted(detail) {
      console.log('Event: onIssueSubmitted', detail);
    },
    onJurisdictionTextUpdated(detail) {
      console.log('Event: onJurisdictionTextUpdated', detail.text);
    },
    onJurisdictionSelectionChange(detail) {
      console.log('Event: onJurisdictionSelectionChange', detail);
    },
    onJurisdictionSelectionSubmitted(detail) {
      console.log('Event: onJurisdictionSelectionSubmitted', detail);
    },
    onNameTextUpdated(detail) {
      console.log('Event: onNameTextUpdated', detail.name);
    },
    onEmailTextUpdated(detail) {
      console.log('Event: onEmailTextUpdated', detail.email);
    },
    onPhoneNumberUpdated(detail) {
      console.log('Event: onPhoneNumberUpdated', detail.phoneNumber);
    },
    onContactDetailsSubmitted(detail) {
      console.log('Event: onContactDetailsSubmitted', detail);
    },
    onIntakeComplete(detail) {
      console.log('Event: onIntakeComplete', detail);
      this.completedIntakeData = detail;
    },
  },
};
</script>

<style>

</style>